<script>
    window.scrollTo(0, 0);

    import Product from "../components/routes/Product.svelte";
    import ButtonSeeMore from "../components/routes/ButtonSeeMore.svelte";
    import {API_URL} from "../../env";
    import {filter, seed, showDialogLogin} from "../js/stores";
    import NotFound from "../placeholders/NotFound.svelte";
    import Error from "../placeholders/Error.svelte";
    import {onMount} from "svelte";
    import {querystring} from "svelte-spa-router";
    import HomeCarousel from "../components/routes/HomeCarousel.svelte";
    import HomeSale from "../components/routes/HomeSale.svelte";
    import ProductsLoading from "../placeholders/ProductsLoading.svelte";

    let buttonDisabled = false

    let maxCount = 0
    let currentCount = 0

    let order = ""

    $: data = fetchData($filter, order)

    async function fetchData (filter) {
        maxCount = 0

        let orderQuery = ""
        if (order.length === 0) {
            orderQuery = $seed
        }
        else {
            orderQuery = order
        }

        const res = await fetch(API_URL+'/products?' + ((orderQuery === "")? "" : `order=${orderQuery}&`) + filter);
        const body = await res.json();
        maxCount = body.count
        currentCount = body.data.length
        return body.data
    }

    async function handleMoreButton(filter) {
        if (buttonDisabled) return;

        buttonDisabled = true
        /* Offset */
        let offset = ""
        if (filter.length > 0) {
            offset += "&"
        }
        offset += `offset=${currentCount}`

        /* Order */
        let orderQuery = ""
        if (order.length === 0) {
            orderQuery = $seed
        }
        else {
            orderQuery = order
        }

        const res = await fetch(API_URL + '/products?' + ((orderQuery === "")? "" : `order=${orderQuery}&`) + filter + offset);

        if (!res.ok) {
            return buttonDisabled = false
        }

        const body = await res.json();
        maxCount = body.count

        Promise.resolve(data).then((value) => {
            data = [...value, ...body.data]
            currentCount += body.data.length
            buttonDisabled = false
        })
    }

    /** New sort buttons **/
    function handleSort(sortOrder) {
        if (order !== sortOrder) {
            order = sortOrder
        }
        else {
            order = ""
        }
    }

    /* PARAMS */
    onMount(() => {
        const urlParams = new URLSearchParams($querystring)

        if ($showDialogLogin.show === false && urlParams.has("m")) {
            let modal = urlParams.get("m")

            if (modal === "prihlasit-sa") {
                showDialogLogin.set({show: true, type: "login", data: {}})
            }
        }
    })
</script>

<HomeCarousel/>

<HomeSale/>

<section class="container" id="products">
    <div class="products">
        <div class="row my-4">
            <div class="col-md-6 col-lg-4">
                <h2 class="section-title">Naša ponuka</h2>
            </div>
            <div class="col-md-6 col-lg-8 my-2 my-md-0 d-flex justify-content-center justify-content-md-end">
                <div class="sorter justify-content-center justify-content-md-end">
                    <button type="button" on:click={() => { handleSort("name_asc") }} class:selected={order === "name_asc"}>
                        <i class="far fa-fw fa-arrow-down-a-z"></i><span>Podľa názvu (A-Z)</span>
                    </button>
                    <button type="button" on:click={() => { handleSort("name_desc") }} class:selected={order === "name_desc"}>
                        <i class="far fa-fw fa-arrow-up-a-z"></i><span>Podľa názvu (Z-A)</span>
                    </button>
                    <button type="button" on:click={() => { handleSort("price_asc") }} class:selected={order === "price_asc"}>
                        <i class="far fa-fw fa-arrow-down-1-9"></i><span>Od najlacnejšieho</span>
                    </button>
                    <button type="button" on:click={() => { handleSort("price_desc") }} class:selected={order === "price_desc"}>
                        <i class="far fa-fw fa-arrow-up-1-9"></i><span>Od najdrahšieho</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    {#await data}
                        <ProductsLoading items={20}/>
                    {:then data}
                        {#if data.length > 0}
                            {#each data as row}
                                <div class="col-md-6 col-lg-4 col-xl-3">
                                    <Product data={row}/>
                                </div>
                            {/each}
                            {#if currentCount > 0 && maxCount > 0 && currentCount < maxCount}
                                <ButtonSeeMore disabled={buttonDisabled} on:click={() => handleMoreButton($filter)}/>
                            {/if}
                        {:else}
                            <NotFound/>
                        {/if}
                    {:catch error}
                        <Error/>
                    {/await}
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .sorter {
        display: flex;
        flex-direction: row;
        place-items: center;
        gap: .5rem;
    }
    .sorter button {
        height: 3rem;
        font-size: .9rem;
        padding: 0 1rem;
        transition: .1s linear;
        cursor: pointer;
        border: 1px solid var(--color-slate-200);
        background-color: var(--color-slate-50);
        color: var(--color-slate-600);
        border-radius: .5rem;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .sorter button i {
        font-size: 1.3rem;
    }
    .sorter button span {
        margin-left: .5rem;
        display: block;
    }
    .sorter button:hover {
        color: black;
        border-color: var(--color-slate-400);
    }
    .sorter button.selected {
        color: white;
        background-color: var(--color-slate-900);
    }
    @media (max-width: 1399.98px) {
        .sorter button span {
            display: none;
        }
    }
</style>